import { Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material'
import Link from 'next/link'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormatter } from '@omnea-app/fe-i18n/useFormatter'
import { generateRequestDetailRoute, RequestTabs } from '@omnea-app/fe-requests/requestRoutes'
import { DefaultChip } from '@omnea-app/frontend/components/shared/ui/chip/DefaultChip'
import { sortAndSliceRows } from '../dashboard-table/sortRows'
import { RfxRow } from './useRfxColumns'

const RfxCard = ({ rfx }: { rfx: RfxRow }) => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'rfx-section' })
  const { formatDateString } = useFormatter()

  // We go to the overview rather than the RFx tab as the RFx tab isn't available on mobile
  const href = generateRequestDetailRoute(RequestTabs.OVERVIEW, rfx.requestId)
  return (
    <Card key={rfx.id}>
      <CardActionArea LinkComponent={Link} href={href}>
        <CardContent>
          <Stack gap={3}>
            <Stack sx={{ justifyContent: 'space-between', flexDirection: 'row' }} alignItems="center">
              <DefaultChip label={t(`table.statuses.${rfx.status}`)} />
              <Typography variant="Body14pxRegular" color="neutralLight.900">
                {t('table.dueDateValue', { date: formatDateString(rfx.dueDate, { format: 'short' }) })}
              </Typography>
            </Stack>

            <Typography variant="Body14pxMedium">{rfx.requestName}</Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export const RfxMobileCards = ({ rfxs }: { rfxs: RfxRow[] }) => {
  const visibleRfxs = useMemo(() => sortAndSliceRows(rfxs), [rfxs])

  return (
    <Stack spacing={3}>
      {visibleRfxs.map((rfx) => (
        <RfxCard key={rfx.id} rfx={rfx} />
      ))}
    </Stack>
  )
}
